const options = {
    pin: 0,
    unpin: 0,
    tolerance: 5,
};
export default options;
